import { Select as BaseSelect, type SelectProps, Spinner } from "@heroui/react";

import { useFieldContext, useLanguage } from "@onesolution/hooks";

import Chip from "../Chip";
import { OpenMode } from "../FormDrawer/FormDrawer";
import { defaultSelectItemsRender, shouldDisplayItemPicker } from "./tools";

export type ItemSelect = { id: string; name: string };

export function Select(
	props: Omit<SelectProps, "children"> & {
		children?: SelectProps["children"];
	},
) {
	const field = useFieldContext<string>();
	const { t } = useLanguage();

	if (!shouldDisplayItemPicker(props.isLoading, props.items)) return null;

	const mode = field.form.state.values.formOpenMode as OpenMode;

	if (mode === OpenMode.details)
		return (
			<div className="flex gap-2">
				{props.label ? (
					<h6 className="w-max text-foreground-500">{props.label} :</h6>
				) : null}
				{props.isLoading ? (
					<Spinner size="sm" />
				) : (
					<Chip>
						{
							(props.items as Array<{ key: string; name: string }>)?.find(
								(item) => item.key === field.state.value,
							)?.name
						}
					</Chip>
				)}
			</div>
		);

	return (
		<BaseSelect
			// Need isMultiline set to true to have a consistent label render, idk why :/
			isMultiline
			placeholder={t("basic.none")}
			labelPlacement="outside"
			aria-label="select"
			defaultSelectedKeys={field.state.value ? [field.state.value] : undefined}
			value={field.state.value}
			onBlur={field.handleBlur}
			onChange={(e) => {
				field.handleChange(e.target.value);
			}}
			errorMessage={t("message.required")}
			{...props}
			items={props.items || []}
		>
			{props.children || defaultSelectItemsRender}
		</BaseSelect>
	);
}
